@if (userUnits) {
  <p-scrollPanel [style]="{ width: '100%', height: '100%' }">
    <form [formGroup]="form.formGroup">
        <div class="field">
            <label>Reservoir Name</label>
            <div class="p-inputgroup">
              <input
                type="text"
                pInputText
                formControlName="name"
                id="name"
              />
            </div>
          </div>

          <div class="field">
            <label>Pressure</label>
            <div>
            <app-validated-number-input
              [id]="'pressure'"
              [control]="control('pressure')"
              [value]="control('pressure').value"
              [validation]="{min: pressureValidation.min, max: pressureValidation.max}"
              [unit]="pressureUnit"
              [inline]="false"
            ></app-validated-number-input>
          </div>

          <div class="field">
            <label>Permeability</label>
            <app-validated-number-input
              [id]="'permeability'"
              [control]="control('permeability')"
              [value]="control('permeability').value"
              [validation]="{ min: 0, max: 100000000 }"
              [unit]="'mD'"
              [inline]="false"
            ></app-validated-number-input>
          </div>

          <div class="field">
            <label>Height</label>
            <app-validated-number-input
              [id]="'height'"
              [control]="control('height')"
              [value]="control('height').value"
              [validation]="{ min: 0, max: 100000000 }"
              [unit]="lengthUnit"
              [inline]="false"
            ></app-validated-number-input>
          </div>

          <div class="field">
            <label>Radial Extent</label>
            <app-validated-number-input
              [id]="'radialExtent'"
              [control]="control('radialExtent')"
              [value]="control('radialExtent').value"
              [validation]="{ min: 0, max: 100000000 }"
              [unit]="lengthUnit"
              [inline]="false"
            ></app-validated-number-input>
          </div>

          <div class="field">
            <label>Skin Factor</label>
            <app-validated-number-input
              [id]="'skinFactor'"
              [control]="control('skinFactor')"
              [value]="control('skinFactor').value"
              [validation]="{ min: 0, max: 100000000 }"
              [unit]="''"
              [inline]="false"
            ></app-validated-number-input>
          </div>
          </div>

          <br>

          <div class="field flex">
            <p-toggleswitch
              formControlName="applyCustomPerformanceIndex"
              (onChange)="customPerformanceIndexChange($event)"
              binary="true"
              inputId="applyCustomPerformanceIndex"
            ></p-toggleswitch>
            <label style="margin-left: 5px;" for="applyCustomPerformanceIndex"> Custom Performance Index (J)</label>
          </div>

          <div class="field">
            <label>Performance Index (J)</label>
            <span class="pl-2">
              <i [pTooltip]="'J is specified with volume rate at Standard Conditions'" class="pi pi-info-circle"></i>
            </span>
            <app-validated-number-input
              [id]="'performanceIndex'"
              [control]="control('performanceIndex')"
              [value]="control('performanceIndex').value"
              [validation]="{ min: 0, max: 100000000 }"
              [unit]="'ft³/hr/psi'"
              [inline]="false"
            ></app-validated-number-input>
          </div>
    </form>
  </p-scrollPanel>
}